import ClaimEnquiry from "../../../model/claim-enquiry/ClaimEnquiry";
import { capitalize } from "../../utils/string";

const addressInfo = (claimEnquiry: ClaimEnquiry) => ({
  user_city: claimEnquiry.contact.address.city,
  user_postal_code: claimEnquiry.contact.address.zipCode,
  user_country: claimEnquiry.contact.address.countryCode,
});

const tripDetails = ({ disruptedFlight, itineraryFlights }: ClaimEnquiry) => {
  const disruptedAirline =
    disruptedFlight?.operatingAirlineName || disruptedFlight?.marketingAirlineName;
  const connections = itineraryFlights
    .slice(0, -1)
    .map((f) => f.arrivalAirport?.iata)
    .join(",");

  return {
    trip_departure: disruptedFlight?.departureAirport?.iata,
    trip_destination: disruptedFlight?.arrivalAirport?.iata,
    disrupted_airline: disruptedAirline,
    trip_date: disruptedFlight?.localDepartureDate,
    connecting_flights: itineraryFlights.length > 1 ? "Y" : "N",
    connections,
  };
};

const disruptedFlight = ({ disruptedFlight }: ClaimEnquiry) => {
  const disruptionSegment = {
    source: disruptedFlight?.departureAirport?.iata,
    destination: disruptedFlight?.arrivalAirport?.iata,
  };

  return {
    disruption_segment: disruptedFlight && disruptionSegment,
  };
};

const disruptionTypeDetails = (claimEnquiry: ClaimEnquiry) => {
  if (claimEnquiry.claimType === "delayed") {
    return {
      delayed_flight: {
        total_delay: capitalize(claimEnquiry.delay),
        disruption_reason: capitalize(claimEnquiry.airlineReason),
      },
    };
  }
  if (claimEnquiry.claimType === "cancelled") {
    return {
      cancelled_flight: {
        total_delay: capitalize(claimEnquiry.delay),
        disruption_reason: capitalize(claimEnquiry.airlineReason),
        disruption_notification: claimEnquiry.informedBeforehandDays ? "Y" : "N",
      },
    };
  }
  if (claimEnquiry.claimType === "overbooked") {
    return {
      denied_boarding: {
        total_delay: capitalize(claimEnquiry.delay),
        reservation_surrendered: claimEnquiry.voluntarilySurrendered ? "Y" : "N",
      },
    };
  }

  return {};
};

const disruptionType = (claimEnquiry: ClaimEnquiry) => ({
  disruption_type: capitalize(claimEnquiry.claimType),
  ...disruptionTypeDetails(claimEnquiry),
});

const compensationInfo = ({ compensationDetails }: ClaimEnquiry) => ({
  total_compensation: compensationDetails.totalItineraryCompensationAmount,
  user_compensation: compensationDetails.totalPassengerCompensationAmount,
});

const regulations = (claimEnquiry: ClaimEnquiry) => {
  return {
    eligible: claimEnquiry.isEligible,
    eligible_on_hold: claimEnquiry.isEligibleOnHold,
    legal_eligible: undefined,
    regulation: claimEnquiry.processingRegulation,
  };
};

const legalInfo = () => ({
  fast_track: undefined,
  jurisdiction: undefined,
});

const otherInfo = (claimEnquiry: ClaimEnquiry) => ({
  assignment_form_reviewed: undefined,
  signature_provided: undefined,
  user_gender: undefined,
  fellow_passengers: claimEnquiry.fellowPassengers.length,
  additional_info_provided: undefined,
  enquiry_id: claimEnquiry.uuid,
});

const buildClaimEnquiryEventProperty = (claimEnquiry: ClaimEnquiry) => ({
  ...addressInfo(claimEnquiry),
  ...tripDetails(claimEnquiry),
  ...disruptedFlight(claimEnquiry),
  ...disruptionType(claimEnquiry),
  ...compensationInfo(claimEnquiry),
  ...regulations(claimEnquiry),
  ...legalInfo(),
  ...otherInfo(claimEnquiry),
});

export default buildClaimEnquiryEventProperty;
